import { useEffect, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Skeleton } from 'antd';
import { useSelector } from 'react-redux';
import { Chat } from '../store/chatbotSlice';
import ChatbotMessage from './Chatbot Message/ChatbotMessage';
import UserMessage from './User Message/UserMessage';
import ChorkiBotLogo from '../../../assets/chorki_bot.svg';
import { commonState } from '../../../app/base/commonSlice';
import { authState } from '../../../app/auth/authSlice';

interface ChatbotContentProps {
  data: Chat[];
  handleQuesId?: (id: number | undefined) => void;
  fetchMoreData: () => void;
  hasMore: any;
}

function ChatbotContent({
  data,
  handleQuesId,
  fetchMoreData,
  hasMore,
}: ChatbotContentProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null); // Reference to the end of messages

  const { chatbotStart, language } = useSelector(commonState);

  useEffect(() => {
    // Scroll to the bottom of the chat when new messages are loaded
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [data]);

  // console.log('ChatbotContent', data);

  const { profile } = useSelector(authState);

  return (
    <div>
      {!chatbotStart ? (
        <div className="p-12">
          <div className="">
            <img
              className="m-auto h-[200px] w-[200px]"
              src={ChorkiBotLogo}
              alt=""
            />
          </div>

          <div className="bg-[#ECECEC] dark:bg-[#1D1D1D] p-12 border-1 rounded-md text-[20px]">
            {/* {data?.text[0]?.msg_contents} */}
            <div>
              {`${language === 'en' ? 'Dear' : 'প্রিয়'} ${profile.first_name} ${
                profile.last_name
              }!`}
            </div>

            <div className="mb-6">
              {`${
                language === 'en'
                  ? 'Hope you are having a great day!'
                  : 'আশা করি আপনার দিন ভালো যাচ্ছে।'
              } `}
            </div>
            <div className="mb-6">
              {`${language === 'en' ? 'I am' : 'আমি'} `}
              <span className="font-bold">
                {`${
                  language === 'en'
                    ? 'ChorkiBot, the MyBRAC ChatBot.'
                    : 'চর্কিবট, মাই-ব্র্যাক এর চ্যাটবট।'
                } `}
              </span>
            </div>
            <div>
              {`${
                language === 'en'
                  ? 'I’m here to help you find things easily.'
                  : 'যে কোন কিছু এখানে সহজে খুঁজে পেতে আমি আপনাকে সাহায্য করবো।'
              } `}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="p-6"
          id="chatbotContent"
          style={{
            height: '55vh',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column-reverse',
          }}
        >
          <div ref={messagesEndRef} />
          {/* Chatbot Message */}
          <InfiniteScroll
            dataLength={data?.length}
            next={() => fetchMoreData()}
            style={{ display: 'flex', flexDirection: 'column-reverse' }}
            hasMore
            loader={
              <div>
                {hasMore && (
                  <div className="my-2">
                    <Skeleton active style={{ width: '100%' }} />
                  </div>
                )}
              </div>
            }
            inverse
            scrollableTarget="chatbotContent"
          >
            {data?.map((item: any) => (
              <div key={item?.id} className="messages">
                {item?.sender === 'BOT' && (
                  <ChatbotMessage
                    data={item?.message}
                    handleQuesId={(id: any) => handleQuesId && handleQuesId(id)}
                  />
                )}
                {item?.sender === 'USER' && (
                  <UserMessage data={item?.message} />
                )}
              </div>
            ))}
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
}

export default ChatbotContent;
